export { default } from "./useTeacherStudentGetList";
